import React from 'react';
import PropTypes, { InferProps } from 'prop-types';
import Form from 'react-bootstrap/Form';
import Stack from 'react-bootstrap/Stack';

const propTypes = {
  stages: PropTypes.arrayOf(
    PropTypes.shape({
      name: PropTypes.string,
      id: PropTypes.number.isRequired,
      group: PropTypes.string,
    })
  ),
  activeStages: PropTypes.array, // This should probably be lifted up a level
  toggleStage: PropTypes.func,
};

export default function stageSelection(props: InferProps<typeof propTypes>): JSX.Element {
  const { stages, activeStages, toggleStage } = props;

  return (
    <>
      <h3 className="stage-select--title">Please select all stages that apply</h3>
      <Form className="stage-select">
        <Stack gap={3} className="col-md-5 mx-auto">
          {stages.map((obj, index) => (
            <Form.Check
              type="checkbox"
              id={obj.name + obj.id}
              label={obj.name}
              onChange={() => toggleStage(obj.id)}
              checked={activeStages.includes(obj)}
              key={`stage_selection_${obj.name}`}
            />
          ))}
        </Stack>
      </Form>
    </>
  );
}
